export default __webpack_public_path__ + "static/media/Aggressive Roadmap.70b63bd8.svg";